import { call, put } from 'redux-saga/effects';
import AcademicDatesDataRepository from '../../../../data/repositories/AcademicDatesDataRepository';
import AcademicDatesRepository from '../../../repositories/AcademicDatesRepository';
import { Types } from './actions';

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_ACADEMIC_CALENDAR_REQUEST });
    const academicDatesRepository: AcademicDatesRepository =
      new AcademicDatesDataRepository();
    const academicDatesResponse = yield call(
      academicDatesRepository.getAcademicDates
    );
    if (!academicDatesResponse) {
      yield put({
        type: Types.GET_ACADEMIC_DATES_FAILURE,
        error: 'Ocurrió un error.'
      });
      return;
    }
    const academicDates: any[] = academicDatesResponse;
    yield put({
      type: Types.GET_ACADEMIC_CALENDAR_SUCCESS,
      data: academicDates
    });
  } catch (error) {
    yield put({
      type: Types.GET_ACADEMIC_CALENDAR_FAILURE,
      error: 'Ocurrió un error al momento de leer el calendario académico.'
    });
  }
}
